import { getTimePeriod, getNumberOfPeriods } from "../../../common/utils/subscriptionCopyHelpers";

function sendUserRatePlanInfo({
    productName,
    pricing
}: { productName?: string; pricing?: { billingPeriod: string } }): void {
    const optimizely = window.optimizely;

    if (!optimizely || !productName || !pricing) {
        return;
    }

    const {
        billingPeriod
    } = pricing;

    const subscriptionType = `${ productName } - ${ getNumberOfPeriods(billingPeriod) } ${ getTimePeriod(billingPeriod) }`;

    optimizely.push({
        type: "user",
        attributes: {
            subscriptionType
        }
    });
}

function sendCustomEvent(eventName?: string): void {
    const optimizely = window.optimizely;

    if (!optimizely || !eventName) {
        return;
    }

    optimizely.push({
        type: "event",
        eventName
    });
}

export default {
    sendUserRatePlanInfo,
    sendCustomEvent
};
